module.exports = __webpack_public_path__ + "img/documento_x.cd96e45b.svg";